import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Main } from '../common/blocks/Main';
import { sanitizeCmsHtml } from '../../texts';
import withTextContext from '../../utils/withTextContext';
import { Banner } from '../common/blocks/Banner';

class NewsFaqPage extends Component {
	render() {
		const { texts } = this.props;
		const { content } = texts.school.newsfaq;

		return (
			<>
				<Banner
					bannerImg={texts.school.images.banners.newsfaq}
					showOnMobile={true}
				>
					<BannerText>
						<h2>Nyheter &amp; FAQ</h2>
						<p>Här publiceras nyheter och annan viktig information som rör Skolportalen, du kan också få svar på frågor via FAQ</p>
					</BannerText>
				</Banner>
				<Main>
					<TextBody>
						{content.newstitle !== "" && (
							<h3>{content.newstitle}</h3>
						)}

						<div
							dangerouslySetInnerHTML={sanitizeCmsHtml(
								content.news
							)}
							style={{
								paddingBottom: '30px',
							}}
						/>
					</TextBody>

					<TextBody>
						{content.faqtitle !== "" && (
							<h3>{content.faqtitle}</h3>
						)}

						<div
							dangerouslySetInnerHTML={sanitizeCmsHtml(
								content.faq
							)}
						/>
					</TextBody>
				</Main>
			</>
		);
	}
}

const TextBody = styled.div`
	max-width: 700px;
	margin-inline: auto;
`

const BannerText = styled.div`
	max-width: 500px;
`

export default withTextContext(
	connect()(NewsFaqPage)
);
